import { useState } from "react";
import { Button } from "@/components/ui/button";
import { History, Upload } from "lucide-react";
import { VersionViewer } from "@/components/VersionViewer";
import { UploadForm } from "@/components/UploadForm";

type Tab = "versions" | "upload";

export function VersionManagement() {
  const [activeTab, setActiveTab] = useState<Tab>("versions");

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2">Version Management</h1>
        <p className="text-muted-foreground">
          View version history and upload new versions of units.json, weapons.json, and divisions.json
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="flex gap-2 mb-6 border-b">
        <Button
          variant={activeTab === "versions" ? "default" : "ghost"}
          onClick={() => setActiveTab("versions")}
          className="rounded-b-none"
        >
          <History className="h-4 w-4 mr-2" />
          Version History
        </Button>
        <Button
          variant={activeTab === "upload" ? "default" : "ghost"}
          onClick={() => setActiveTab("upload")}
          className="rounded-b-none"
        >
          <Upload className="h-4 w-4 mr-2" />
          Upload Version
        </Button>
      </div>

      {/* Tab Content */}
      <div className="max-w-6xl mx-auto">
        {activeTab === "versions" && <VersionViewer />}
        {activeTab === "upload" && <UploadForm />}
      </div>
    </div>
  );
}

